import state from '@/core/store/flowbee/state'
import actions from '@/core/store/flowbee/actions'
import mutations from '@/core/store/flowbee/mutations'
export default {
	state,
	actions,
	mutations,
}
